<template>
    <div id="app">
        <hatadialog ref="hatadialog"></hatadialog>
        <v-app id="inspire" light>
            <v-card color="grey lighten-5" flat>
                <v-layout row wrap>
                    <v-container fluid>
                        <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
                            <v-layout row wrap>
                                <v-flex pb-3 xs12 sm12 md12>
                                    <v-card flat>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm6 pt-2 md2>
                                                <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                                                    :rules="[v => !!v || $t('Please-select-a-date')]"
                                                    v-bind:defaultvalue="'ok'" v-bind:value="Rapor.KayitTarihiBasla"
                                                    v-model="Rapor.KayitTarihiBasla"></tarihcomp>
                                            </v-flex>

                                            <v-flex xs12 pt-2 sm6 md2>
                                                <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                                                    :rules="[v => !!v || $t('Please-select-a-date')]"
                                                    v-bind:defaultvalue="'ok'" v-bind:value="Rapor.KayitTarihiBitis"
                                                    v-model="Rapor.KayitTarihiBitis"></tarihcomp>
                                            </v-flex>
                                            <v-flex pt-2>
                                                <v-layout>
                                                    <div v-if="load1">
                                                        <v-btn color="info" @click="getList()" fab small dark>
                                                            <v-icon>search</v-icon>
                                                        </v-btn>
                                                    </div>
                                                    <div v-if="progress">
                                                        <v-layout pt-3 align-center>
                                                            <v-progress-circular indeterminate :width="4"
                                                                color="blue"></v-progress-circular>
                                                        </v-layout>
                                                    </div>
                                                    <v-badge color="white" :overlap="true">
                                                        <template v-slot:badge>
                                                            <v-icon v-if="filtrevarmi" large
                                                                color="green">check_circle_outline</v-icon>
                                                        </template>

                                                        <v-btn small @mouseenter="tooltip = true"
                                                            @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                                                            color="info" fab dark>
                                                            <v-icon>filter_list</v-icon>
                                                        </v-btn>
                                                        <v-tooltip bottom :activator="el" v-model="tooltip">
                                                            <span>{{ $t('Add-Search-Filter') }}</span>
                                                        </v-tooltip>
                                                    </v-badge>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 sm12 md12 pb-3>
                                    <v-card flat class="white--text">
                                        <v-card flat>
                                            <v-card-actions>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12>
                                                        <v-card flat>
                                                            <v-data-table :headers="headerssatis"
                                                                :rows-per-page-items="[20, 100]" :items="itemssatis"
                                                                :search="searchara">
                                                                <template slot="items" slot-scope="props">
                                                                    <tr item>
                                                                        <td class="text-xs-left">{{ props.item.PNR_No }}
                                                                        </td>
                                                                        <td class="text-xs-left">{{
                                                                            formatDate(props.item.CreatedDate) }}</td>
                                                                        <td class="text-xs-left"><span
                                                                                v-for="isim in props.item.IsimSatisFiyat">{{
                                                                                    isim.isim }}</span></td>
                                                                        <td class="text-xs-left">{{
                                                                            props.item.IsAciklama }}</td>
                                                                        <td class="text-xs-left">{{ props.item.CariKod
                                                                            }}</td>
                                                                        <td class="text-xs-left">{{ props.item.Satici }}
                                                                        </td>
                                                                        <td class="text-xs-left">{{ props.item.Kur }}
                                                                        </td>
                                                                        <td class="text-xs-left">{{
                                                                            props.item.ToplamSatisFiyat | moneyformat }}
                                                                            {{ props.item.Para }}</td>
                                                                        <td>
                                                                            <v-btn icon small slot="activator" flat
                                                                                @click="git(props.item)">
                                                                                <v-icon color="info">search</v-icon>
                                                                            </v-btn>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                                <v-alert slot="no-results" :value="true" color="error"
                                                                    icon="warning">
                                                                    {{ $t('No-records-searched-for', {
                                                                        value:
                                                                            searchara
                                                                    }) }}
                                                                </v-alert>
                                                            </v-data-table>
                                                        </v-card>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-actions>
                                        </v-card>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>

                    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                        v-model="snackbar">
                        {{ text1 }}
                        <v-btn flat color="pink" @click.native="snackbar = false">{{ $t('Close') }}</v-btn>
                    </v-snackbar>

                    <v-dialog v-model="dialogfiltre" scrollable persistent max-width="400px">
                        <v-card flat color="grey lighten-4">
                            <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 md12 pa-1>
                                        <v-card flat class="white--text">
                                            <v-card flat color="grey lighten-5">
                                                <v-card-actions>

                                                    <v-layout row wrap>
                                                        <v-flex md12 xs12 sm12>
                                                            <pnrbul v-model="Rapor.Prm.PPNR_No" hide-details>
                                                            </pnrbul>
                                                        </v-flex>

                                                        <v-flex md12 xs12 sm12>
                                                            <cariaracomp v-bind:etiket="$t('Currentcode_label')"
                                                                v-bind:value="Rapor.Prm.PCariKod"
                                                                v-model="Rapor.Prm.PCariKod" :Coper="true">
                                                            </cariaracomp>
                                                        </v-flex>


                                                        <v-flex xs12 sm12 md12>
                                                            <genelarama :autofocuss="true" apiname="SaticiAra"
                                                                :tip="Rapor.Prm.PSaticiTip" :label="$t('Seller-Code')"
                                                                v-model="Rapor.Prm.PSaticiKod"></genelarama>
                                                        </v-flex>

                                                        <v-flex xs9 md6 sm8>
                                                            <v-select hide-details v-model="secilenEtiketler"
                                                                :items="TurEtiketler"
                                                                :rules="[(v) => !!v || $t('Mandatory-section')]"
                                                                item-text="EtiketAd" item-value="Id" label="Etiketler"
                                                                chips clearable multiple return-object></v-select>
                                                        </v-flex>
                                                        <v-flex>
                                                            <v-text-field v-model="turAdi"
                                                                label="Tur Adı "></v-text-field>
                                                            <v-text-field v-model="turKodu"
                                                                label="Tur Kodu"></v-text-field>
                                                        </v-flex>
                                                        <v-flex>
                                                            <v-text-field v-model="yolcuAdi"
                                                                label="Yolcu Adı"></v-text-field>
                                                            <v-text-field v-model="yolcuSoyadi"
                                                                label="Yolcu Soyadı"></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs9 md6 sm12>
                                                            <v-select label="Kategori" item-text="Aciklama"
                                                                item-value="Id" :items="kategoriler"
                                                                v-model="kategori"></v-select>
                                                        </v-flex>
                                                        <v-flex xs9 md6 sm12>
                                                            <v-select label="Ürün Grubu" item-text="Aciklama"
                                                                item-value="Id" :items="urungruplari"
                                                                v-model="urunGrubu"></v-select>
                                                        </v-flex>
                                                        <v-flex xs9 md4 sm8>
                                                            <v-text-field label="Gündüz" maxlength="15" hide-details=""
                                                                v-model="gunduz" type="number">
                                                            </v-text-field>
                                                        </v-flex>
                                                        <v-flex xs9 md4 sm8>
                                                            <v-text-field label="Gece" maxlength="15" hide-details=""
                                                                v-model="gece" type="number">
                                                            </v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-actions>
                                            </v-card>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{ $t("cancel_button")
                                    }}</v-btn>
                                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters')
                                    }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-if="iptalDialog" v-model="iptalDialog" max-width="450px">
                        <v-card>
                            <v-card-text>
                                <v-container>

                                    <v-form ref="formiptal" v-model="valid" lazy-validation>
                                        <v-layout class="  project overdue" row wrap>
                                            <v-flex xs12 pb-2 sm12 md12>
                                                <v-layout row wrap>

                                                    <v-toolbar flat="" size="120px" dark color="white">
                                                        <v-toolbar-title> <span class="subheading black--text">
                                                                {{ $t('Details-of-PNR-Cancelled') }}
                                                            </span> </v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                    </v-toolbar>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex pl-4 xs3 md3 sm3>
                                                <span> {{ $t('PNR-No') }} </span>
                                            </v-flex>
                                            <v-flex xs9 md9 sm9>
                                                <span>:{{ secilenKayit.PNR_No }} </span>
                                            </v-flex>
                                            <v-flex xs3 pl-4 md3 sm3>
                                                <span> {{ $t('Current') }} </span>
                                            </v-flex>
                                            <v-flex xs9 md9 sm9>
                                                <span>:{{ secilenKayit.CariKod }}-{{ secilenKayit.Unvan }} </span>
                                            </v-flex>

                                        </v-layout>
                                        <v-flex pl-4 pt-2 xs12 md12 sm12>
                                            <v-text-field hide-details :rules="[v => !!v || $t('Mandatory-Areas')]"
                                                v-model="IptalNedeni"
                                                :label="$t('Reason-of-Cancellation')"></v-text-field>
                                        </v-flex>
                                    </v-form>

                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="info" flat="flat" @click.native="iptalDialog = false">{{
                                    $t("cancel_button") }}</v-btn>
                                <v-btn color="info" flat @click.native="pnrIptal()">{{ $t('OK') }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-layout>
            </v-card>
        </v-app>
    </div>
</template>

<script>
import auth from "../../../../api/auth";
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../coper/tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import anatip from "@/components/app/coper/comp/anatip.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
import takipno from '@/components/app/coper/component/takipno.vue'

export default {
    data() {
        return {

            itemskomisyon: [{
                text: this.$t('None'),
                value: false
            }, {
                text: this.$t('Available'),
                value: true
            }, {
                text: this.$t('All-v2'),
                value: null
            }],
            yolcuAdi: "",
            yolcuSoyadi: "",
            gece: 0,
            gunduz: 0,
            urunGrubu: 0,
            kategori: 0,
            kategoriler: [],
            urungruplari: [],
            turAdi: "",
            turKodu: "",
            searchara: null,
            IptalNedeni: null,
            iptalDialog: false,
            secilenKayit: {},
            TurEtiketler: [],
            secilenEtiketler: [],
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0
            },
            filtrevarmi: false,
            search: "",
            searchsatilanbilet: null,
            searchiadebilet: null,
            searchvoid: null,

            headerssatis: [

                {
                    text: this.$t('PNR-No'),
                    value: "PNR_No",
                    width: "5%",
                    align: "left"
                },

                {
                    text: "Kayıt Tarihi",
                    value: "CreatedDate",
                    width: "10%",
                    align: "left"
                },
                {
                    text: "Kişiler",
                    value: "isim",
                    width: "15%",
                    align: "left"
                },
                {
                    text: "Paket",
                    value: "IsAciklama",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Currentcode_label'),
                    value: "CariKod",
                    width: "10%",
                    align: "left"
                },
                {
                    text: "Satıcı",
                    value: "Satici",
                    width: "15%",
                    align: "left"
                },
                {
                    text: "Kur",
                    value: "Kur",
                    width: "10%",
                    align: "left"
                },
                {
                    text: "Satış",
                    value: "ToplamSatisFiyat",
                    width: "10%",
                    align: "left"
                },
                {
                    text: "İşlem",
                    value: "islem",
                    sortable: false

                },
            ],

            Rapor: {
                KayitTarihiBasla: null,
                KayitTarihiBitis: null,
                ParaBirimi: "TL",
                TakipNo: null,
                Prm: {
                    PCariKod: null,
                    PPNR_No: null,
                    PSirketNo: null,
                    PCariSirket: null,
                    PPNR_ParaBirimi: null,
                    PKayitTarihBas: null,
                    PKayitTarihBit: null,
                    PDonem1Bas: null,
                    PDonem1Bit: null,
                    PDonem2Bas: null,
                    PDonem2Bit: null,
                    PFatTarihBas: null,
                    PFatTarihBit: null,
                    PKomFatTarihBas: null,
                    PKomFatTarihBit: null,
                    PSaticiTip: null,
                    PSaticiKod: null,
                    PDosyaTip: null,
                    PDosya: null,
                    PAcente: null,
                    PPNRBir: null,
                    PCariHesapGrubu: null,
                    PCariTip: null,
                    PSaticiGrup: null,
                    PSaticiIc_Dis: null,
                    PTurOp: null,
                    PFaturali: null,
                    POpsiyon: null,
                    PAnaTip: null,
                    PCariAnaHesap: null,
                    PIptalRaporu: null,
                    PRezGrupID: null,
                    PSatisGrubu: null,
                    PSatisGrupTip: null,
                    PSaticiOdemesiHesapla: null,
                    PMasrafMerkezi: null,
                    PAcenteDepartmanID: null,
                    PPozisyonNo: null,
                    PSatisFaturaNo: null,
                    PMusteriOdemelilerHaric: null,
                    PReferans: null,
                    PSatisTip1: null,
                    PSatisTip2: null,
                    PSatisTip3: null,
                    PSatisTip4: null,
                    PGelenFatTarihBas: null,
                    PGelenFatTarihBit: null,
                    PProfilSablonId: null,
                    PKomisyonFaturali: null,
                    PGelenFaturali: null,
                }
            },

            TurOperatoru: {
                id: null,
                kod: null,
                isim: null,
                tip: 0
            },
            itemsairlinelist: [],
            hesapgurubu: [],
            masrafmerkezi: [],
            doviztipi: [],
            valid: true,
            tumsirketler: "",
            totalCount: 0,
            totalService: 0,
            totalAmount: 0,
            StartDate: null,
            EndDate: null,
            date: null,
            menu: false,
            modal: false,
            dateFormatted: "",
            date2: null,
            menu2: false,
            dateFormatted2: "",
            modal2: false,
            loading: false,
            items: [],
            load: false,
            load1: true,
            search3: "",

            renk1: "info",
            dialogfiltre: false,
            hesapkodu: [],
            kredikarti: [],
            statecari: [],
            searchcari: "",
            progress: false,
            tooltip: false,
            el: null,
            yok: false,
            itemssatis: [],
            itemsiade: [],
            itemsvoid: [],

            butondurum: true,
            snackbar: false,
            y: "top",
            x: "right",
            mode: "",
            timeout: 6000,
            text1: "",
            dictionary: {
                custom: {
                    tarihsec: {
                        required: () => this.$t('Please-choose-a-date')
                    },
                    tarihsec1: {
                        required: () => this.$t('Please-choose-a-date')
                    }
                }
            }
        };
    },
    props: {
        MasterTurId: {
            type: String,
            required: true,
        },
        PaketId: {
            type: String,
            required: true,
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path;
        });
    },
    beforeMount: beforeMount,
    mounted() {
        this.getEtiketList();
        this.getkategoriler();
        this.geturungruplari();
        this.$validator.localize("en", this.dictionary);
        this.el = this.$refs.fab.$el;
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        moneyformat: function (m) {
            return helpers.moneyformat(m);
        },

        bakiyekontrol: function (m) {
            return helpers.bakiyekontrol(m);
        }
    },

    components: {
        tarihcomp: tarihcomp,
        yetkidialog,
        hatadialog,
        pnrbul,
        anatip,
        genelarama,
        referansmerkezicomp,
        cariaracomp,
        takipno
    },
    watch: {},
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString("tr-TR", {
                day: "numeric", // Günü gösterir
                month: "long",  // Ay adını gösterir (örnek: Aralık)
                year: "numeric",
            });
        },
        getReportExcel() {
            if (this.$refs.formgunluksatis.validate()) {
                var bastarih = new Date(this.Rapor.KayitTarihiBasla);
                var bittarih = new Date(this.Rapor.KayitTarihiBitis);

                if (bastarih <= bittarih) {
                    this.progress = true;
                    this.load1 = false;
                    var credentials = JSON.parse(window.localStorage.getItem("credentials"));

                    var paramsExcel = {
                        PSirketNo: credentials.CoperSirketNo,
                        PCariSirket: credentials.SirketKodu,
                        PPNR_No: this.Rapor.Prm.PPNR_No,
                        PPNR_ParaBirimi: this.Rapor.Prm.PPNR_ParaBirimi,
                        PKayitTarihBas: this.Rapor.KayitTarihiBasla,
                        PKayitTarihBit: this.Rapor.KayitTarihiBitis,
                        PDonem1Bas: this.Rapor.Prm.PDonem1Bas,
                        PDonem1Bit: this.Rapor.Prm.PDonem1Bit,
                        PDonem2Bas: this.Rapor.Prm.PDonem2Bas,
                        PDonem2Bit: this.Rapor.Prm.PDonem2Bit,
                        PFatTarihBas: this.Rapor.Prm.PFatTarihBas,
                        PFatTarihBit: this.Rapor.Prm.PFatTarihBit,
                        PKomFatTarihBas: this.Rapor.Prm.PKomFatTarihBas,
                        PKomFatTarihBit: this.Rapor.Prm.PKomFatTarihBit,
                        PCariKod: null,
                        PSaticiTip: this.Rapor.Prm.PSaticiTip,
                        PSaticiKod: null,
                        PDosyaTip: this.Rapor.Prm.PDosyaTip,
                        PDosya: this.Rapor.Prm.PDosya,
                        PAcente: this.Rapor.Prm.PAcente,
                        PPNRBir: this.Rapor.Prm.PPNRBir,
                        PCariHesapGrubu: this.Rapor.Prm.PCariHesapGrubu,
                        PCariTip: this.Rapor.Prm.PCariTip,
                        PSaticiGrup: this.Rapor.Prm.PSaticiGrup,
                        PSaticiIc_Dis: this.Rapor.Prm.PSaticiIc_Dis,
                        PTurOp: null,
                        PFaturali: this.Rapor.Prm.PFaturali,
                        POpsiyon: this.Rapor.Prm.POpsiyon,
                        PAnaTip: this.Rapor.Prm.PAnaTip,
                        PCariAnaHesap: null,
                        PIptalRaporu: this.Rapor.Prm.PIptalRaporu,
                        PRezGrupID: this.Rapor.Prm.PRezGrupID,
                        PSatisGrubu: this.Rapor.Prm.PSatisGrubu,
                        PSatisGrupTip: this.Rapor.Prm.PSatisGrupTip,
                        PSaticiOdemesiHesapla: this.Rapor.Prm.PSaticiOdemesiHesapla,
                        PMasrafMerkezi: null,
                        PPNR_ParaBirimi: this.Rapor.ParaBirimi,
                        PAcenteDepartmanID: this.Rapor.Prm.PAcenteDepartmanID,
                        PPozisyonNo: this.Rapor.Prm.PPozisyonNo,
                        PSatisFaturaNo: this.Rapor.Prm.PSatisFaturaNo,
                        PMusteriOdemelilerHaric: this.Rapor.Prm.PMusteriOdemelilerHaric,
                        PReferans: this.Rapor.Prm.PReferans,
                        PSatisTip1: this.Rapor.Prm.PSatisTip1,
                        PSatisTip2: this.Rapor.Prm.PSatisTip2,
                        PSatisTip3: this.Rapor.Prm.PSatisTip3,
                        PSatisTip4: this.Rapor.Prm.PSatisTip4,
                        PGelenFatTarihBas: this.Rapor.Prm.PGelenFatTarihBas,
                        PGelenFatTarihBit: this.Rapor.Prm.PGelenFatTarihBit,
                        PProfilSablonId: this.Rapor.Prm.PProfilSablonId,
                        PKomisyonFaturali: this.Rapor.Prm.PKomisyonFaturali,
                        PGelenFaturali: this.Rapor.Prm.PGelenFaturali

                    }

                    if (this.Rapor.Prm.PCariKod != null) {
                        paramsExcel.PCariKod = this.Rapor.Prm.PCariKod.id
                    } else {
                        paramsExcel.PCariKod = this.Rapor.Prm.PCariKod
                    }

                    if (this.Rapor.Prm.PSaticiKod != null) {
                        paramsExcel.PSaticiKod = this.Rapor.Prm.PSaticiKod.kod
                    } else {
                        paramsExcel.PSaticiKod = this.Rapor.Prm.PSaticiKod
                    }

                    if (this.Rapor.Prm.PCariAnaHesap != null) {
                        paramsExcel.PCariAnaHesap = this.Rapor.Prm.PCariAnaHesap.id
                    } else {
                        paramsExcel.PCariAnaHesap = this.Rapor.Prm.PCariAnaHesap
                    }

                    if (this.Rapor.Prm.PMasrafMerkezi != null) {
                        paramsExcel.PMasrafMerkezi = this.Rapor.Prm.PMasrafMerkezi.kod
                    } else {
                        paramsExcel.PMasrafMerkezi = this.Rapor.Prm.PMasrafMerkezi
                    }

                    if (this.Rapor.Prm.PTurOp != null) {
                        paramsExcel.PTurOp = this.Rapor.Prm.PTurOp.kod
                    } else {
                        paramsExcel.PTurOp = this.Rapor.Prm.PTurOp
                    }

                    var params = {
                        Prm: paramsExcel
                    }

                    tool.http_post(this, "ExcelSatisRaporu", params).then(
                        response => {
                            if (response.body.Status == true) {
                                //   this.itemssatis = response.body.data;

                                this.progress = false;
                                this.load1 = true;
                            } else {
                                this.text1 = response.body.ErrorList[0];
                                this.snackbar = true;
                                this.progress = false;
                                this.load1 = true;
                            }
                        },
                        response => {
                            this.HataYonetimi(response, params, 'Satış Listesi Getirilemedi');
                            this.progress = false;
                            this.load1 = true;
                        }
                    );
                } else {
                    this.text1 = this.$t('start-date-cannot-greater-than-end-date')
                    this.snackbar = true;
                }
            }

        },

        pnrIptalDialog(val) {
            this.iptalDialog = true
            this.IptalNedeni = null
            this.secilenKayit = val
        },

        pnrIptal() {
            if (this.$refs.formiptal.validate()) {

                let params = {
                    IptalTipi: 1, //PNR iptalinde 1, Takip No iptalinde 2 olacak, Henüz Takip No iptal yapılmadı.
                    IptalNo: this.secilenKayit.PNR_No, //PNR No veya Takip No
                    IptalNedeni: this.IptalNedeni
                }

                tool.http_post(this, 'RezervasyonIptal', params).then(

                    response => {

                        if (response.body.Status == true) {
                            this.text1 = "PNR iptal edildi."
                            this.snackbar = true
                            this.iptalDialog = false

                            this.getList();

                        } else {
                            this.text1 = response.body.ErrorList[0]
                            this.snackbar = true
                        }
                    },
                    response => {
                        this.text1 = this.$t('An-error-has-occurred-Please-try-again')
                        this.snackbar = true
                    }
                );
            }

        },
        HataYonetimi(response, request, baslik) {
            if (response.status === 500) {
                //Internal Server Error
                this.$refs.hatadialog.open(response, request, baslik);
            } else {
                this.text1 = "Service Unavailable -" + baslik;
                this.snackbar = true;
            }
        },

        git(val) {
            if (val.TakipNo != null) {
                var url = "#/coper/vize/yeni/id?islem=get&TakipNo=" + val.TakipNo;
                window.open(url, "_target");
            } else {
                var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
                window.open(url, "_target");
            }

            // var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
            // window.open(url, "_target");

        },
        getEtiketList() {
            let params = {
                Ara: this.searchara,
            };
            tool.http_post(this, "TurEtiketList", params).then(
                (response) => {
                    if (response.body.Status == true) {
                        this.TurEtiketler = response.body.data;
                    } else {
                        this.text1 = response.body.ErrorList[0];
                        this.snackbar = true;
                    }
                },
                (response) => {
                    this.text1 = $t('Error-Occured-Please-Try-Again')
                    this.snackbar = true;
                }
            );
        },
        getkategoriler() {
            let params = {
                TanitimTip: 9,
            };

            tool.http_post(this, "GenelTipTanitimList", params).then(
                (response) => {
                    if (response.body.Status == true) {

                        this.kategoriler = response.body.data;

                    } else {
                        this.text1 = response.body.ErrorList[0];

                        this.snackbar = true;
                    }
                },

                (response) => {
                    this.text1 = $t('Error-Occured-Please-Try-Again')
                    this.snackbar = true;
                }
            );
        },
        getParkurs() {
            var params1 = {
                CompanyCode: this.credentials.SirketKodu
            }
            this.classdialog = false
            this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.Parkurs = response.body

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })
        },

        geturungruplari() {
            let params = {
                TanitimTip: 10,
            };

            tool.http_post(this, "GenelTipTanitimList", params).then(
                (response) => {
                    if (response.body.Status == true) {
                        this.urungruplari = response.body.data;
                    } else {
                        this.text1 = response.body.ErrorList[0];
                        this.snackbar = true;
                    }
                },
                (response) => {
                    this.text1 = $t('Error-Occured-Please-Try-Again')
                    this.snackbar = true;
                }
            );
        },
        getList: getList,
        filtrele: filtrele,
        filtrekayit: filtrekayit,
        filtreiptal: filtreiptal
    }
};

function filtrele() {
    this.dialogfiltre = true;
}

function filtrekayit() {
    this.filtrevarmi = true;
    this.dialogfiltre = false;
    this.getList();
}



function filtreiptal() {
    this.filtrevarmi = false;
    this.dialogfiltre = false;

    this.Rapor.TakipNo = null;

    this.Rapor.Prm.PPNR_No = null;
    this.Rapor.Prm.PPNR_ParaBirimi = null
    this.Rapor.Prm.PCariKod = null
    this.Rapor.Prm.PSaticiTip = null
    this.Rapor.Prm.PSaticiKod = null
    this.Rapor.Prm.PDosyaTip = null
    this.Rapor.Prm.PDosya = null
    this.Rapor.Prm.PAcente = null
    this.Rapor.Prm.PPNRBir = null
    this.Rapor.Prm.PCariHesapGrubu = null
    this.Rapor.Prm.PCariTip = null
    this.Rapor.Prm.PSaticiGrup = null
    this.Rapor.Prm.PSaticiIc_Dis = null
    this.Rapor.Prm.PTurOp = null
    this.Rapor.Prm.PFaturali = null
    this.Rapor.Prm.POpsiyon = null
    this.Rapor.Prm.PAnaTip = null
    this.Rapor.Prm.PCariAnaHesap = null

    this.getList();

}

function getList() {
    if (this.$refs.formgunluksatis.validate()) {
        var bastarih = new Date(this.Rapor.KayitTarihiBasla);
        var bittarih = new Date(this.Rapor.KayitTarihiBitis);

        if (bastarih <= bittarih) {
            this.progress = true;
            this.load1 = false;

            var credentials = JSON.parse(window.localStorage.getItem("credentials"));

            var RaporParam = {
                KayitTarihiBasla: this.Rapor.KayitTarihiBasla,
                KayitTarihiBitis: this.Rapor.KayitTarihiBitis,
                ParaBirimi: null,
                TakipNo: null,
                Prm: {},
                PaketId: this.PaketId,
                MasterTurId: this.MasterTurId,
                CariKod: this.Rapor.Prm.PCariKod,
                SaticiKod: this.Rapor.Prm.PSaticiKod,
                Etiketler: this.secilenEtiketler,
                TurKodu: this.turKodu,
                TurAdi: this.turAdi,
                Gece: this.gece,
                Gunduz: this.gunduz,
                UrunGrubu: this.urunGrubu,
                Kategori: this.kategori,
                YolcuAdi: this.yolcuAdi,
                YolcuSoyadi: this.yolcuSoyadi,
            }
            tool.http_post(this, "PaketRezervasyonlarGetir", RaporParam).then(
                response => {
                    if (response.body.Status == true) {
                        this.itemssatis = response.body.data;

                        this.progress = false;
                        this.load1 = true;
                    } else {
                        this.text1 = response.body.ErrorList[0];
                        this.snackbar = true;
                        this.progress = false;
                        this.load1 = true;
                    }
                },
                response => {
                    this.HataYonetimi(response, params, 'Satış Listesi Getirilemedi');
                    this.progress = false;
                    this.load1 = true;
                }
            );
        } else {
            this.text1 = this.$t('start-date-cannot-greater-than-end-date')
            this.snackbar = true;
        }
    }
}

function beforeMount() { }
</script>

<style></style>